import React from "react";
import {
    IconButton, Menu, MenuItem, ListItemIcon, ListItemText,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

export default function EditCloneDeleteMenu({ onEdit, onClone, onDelete }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [confirmOpen, setConfirmOpen] = React.useState(false);

    const open = Boolean(anchorEl);

    const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
    const handleMenuClose = () => setAnchorEl(null);

    const handleDeleteClick = () => {
        setConfirmOpen(true);
        handleMenuClose();
    };

    const handleConfirmClose = () => setConfirmOpen(false);

    const handleConfirmDelete = () => {
        onDelete(); // Call the actual delete callback
        setConfirmOpen(false);
    };

    return (
        <>
            <IconButton onClick={handleMenuOpen}>
                <MoreVertIcon fontSize="small" />
            </IconButton>
            <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
                <MenuItem onClick={() => { onEdit(); handleMenuClose(); }}>
                    <ListItemIcon><EditIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>Edit</ListItemText>
                </MenuItem>
                <MenuItem onClick={() => { onClone(); handleMenuClose(); }}>
                    <ListItemIcon><PeopleAltIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>Clone</ListItemText>
                </MenuItem>
                <MenuItem onClick={handleDeleteClick}>
                    <ListItemIcon><DeleteOutlineIcon fontSize="small" /></ListItemIcon>
                    <ListItemText>Delete</ListItemText>
                </MenuItem>
            </Menu>

            <Dialog open={confirmOpen} onClose={handleConfirmClose}>
                <DialogTitle>Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this record? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmDelete} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
